import { CaseManagement } from '../components/CaseManagement';

export function AdminCasesPage() {
  return <CaseManagement />;
}